export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCHFIELDs'


// WEBPACK FOOTER //
// ./src/constants.js